import { useContext } from "react";
import { CompanyMetadataContext, CompanyMetadataInit } from "./context";

export const useCompanyMetadata = () => {
    const context = useContext(CompanyMetadataContext);

    if (context) {
        return context;
    }

    throw new Error(`useCompanyMetadata must be used within the context`);
};

export const useCompanyMetadataSafe = (): CompanyMetadataInit | null => {
    return useContext(CompanyMetadataContext);
};
